import HeaderUserActions from "./HeaderUserActions";

export default function Header({}){
    return (
        <div className="p-4 z-10 flex shadow-md bg-white max-w-[100vw]">
            <h1 className="text-2xl font-light text-ellipsis text-truncate">Cemetery Map | Glenwood Cemetery</h1>
            <hr className="flex-grow border-0" />
            <HeaderUserActions />
        </div>
    )
}